import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import PatternSamples from "@root/ts/PatternSamples";
import EZAlert from "./EZAlert";
import FormTools from "@root/ts/FormTools";
import schema from "@schema/common/subscribe-to-newsletter.json";

export default class Footer extends ComponentBase
{
  constructor(elem: ComponentElem)
  {
    super(elem);
   
    let inputElem = this.$root.find("input")[0] as HTMLInputElement;
    inputElem.value = "";

    this.$root.find(".btn-enter").on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();

      let value = inputElem.value;
      
      if(PatternSamples.email.test(value))
      {
        let formData = {email: value};
        FormTools.sendForm("common/subscribe-to-newsletter", formData, undefined, {schema: schema}).then(()=>
        {
          EZAlert.alert("郵件訂閱成功");
          inputElem.value = "";
        });
      }
      else
      {
        EZAlert.alert("請輸入正確的 email 格式");
      }
    }); 
  }
}